import Suggestion from '@web-platform/shared-banana-utils-frontend/src/helpers/autoSuggest/index';
import { suggestionToSearchPlace } from '@web-platform/shared-banana-utils-frontend/src/helpers/suggestionToSearchPlace';
import { DATE_FORMATS } from '@web-platform/shared-universal-constants/src/dateFormats';
import { EVERYWHERE } from '@web-platform/shared-universal-constants/src/places';
import { ANALYTICS_EVENTS } from '@web-platform/shared-universal-constants-tracking';
import { getOrigin } from '@web-platform/shared-universal-redux/src/selectors/search';
import { getCurrentScreenName } from '@web-platform/shared-universal-redux/src/selectors/trustedFunnel';
import { getUserSearch } from '@web-platform/shared-universal-redux/src/state';
import { getInitialState } from '@web-platform/shared-universal-redux/src/state/appInitial/user/search/initialState';
import { translate } from '@web-platform/shared-universal-translations';
import { makeEntityId } from '@web-platform/shared-universal-types-utils/src/utils';
import { formatDateNonlocalised } from '@web-platform/shared-universal-utils-frontend-localisation';
import { addMonths } from 'date-fns/addMonths';
import { useSelector } from 'react-redux';

import { useCombinedResultsSearch } from './useCombinedResultsSearch';

import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';
import type { TrackInteractionEvent } from '@web-platform/shared-universal-types-tracking/src/trackInteractionEvent/trackInteractionEvent';

type EverywhereSearchProps = {
  tracking: { trackInteractionEvent: TrackInteractionEvent };
};

export const useEverywhereSearchNavigation = ({ tracking }: EverywhereSearchProps) => {
  const { goToCombinedResults } = useCombinedResultsSearch();

  const fallbackOrigin: SearchLegPlace = {
    entityId: makeEntityId('29475375'),
    id: 'UK',
    name: 'United Kingdom',
    countryId: 'UK',
    type: 'Nation',
    centroidCoordinates: [-2.9767221462, 54.2532367516],
    travelEntityId: makeEntityId('29475375'),
  };

  const suggestion = new Suggestion({
    CityId: null,
    CityName: null,
    Everywhere: true,
    PlaceId: EVERYWHERE,
    PlaceName: translate('ktxt_everywhere'),
  });

  const origin = useSelector(getOrigin) || fallbackOrigin;
  const screenName = useSelector(getCurrentScreenName);
  const { prefer_directs } = useSelector(getUserSearch);

  const handleEverywhereSearchNavigation = () => {
    const everywhereDestination = suggestionToSearchPlace(suggestion);
    tracking.trackInteractionEvent({
      name: ANALYTICS_EVENTS.INTERACTION.DESTINATION_SELECTED.NAME,
      strings: {
        destination: everywhereDestination.id,
        source: screenName,
      },
    });

    const month = addMonths(new Date(), 1);
    const monthDate = formatDateNonlocalised(month, DATE_FORMATS.YEAR_MONTH_FULL_DASHED);

    // set default param values
    const redirectParams = {
      ...getInitialState(),
      prefer_directs,
      legs: [
        { origin, destination: everywhereDestination, date: monthDate, return_date: monthDate },
      ],
    };

    goToCombinedResults(redirectParams);
  };

  return {
    handleEverywhereSearchNavigation,
  };
};
